import { render, staticRenderFns } from "./EventMarketingImportForm.vue?vue&type=template&id=3207b374"
import script from "./EventMarketingImportForm.vue?vue&type=script&lang=js"
export * from "./EventMarketingImportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports